<div class="dashboard--module-header">
    <h2 class="subheading-sm">
        Current tariffs <button class="info-btn focus-element" (click)="onInfoClick()" ><span class="focus--content" tabindex="-1" ><span>i</span></span></button>
        <span class="subheading--status" *ngIf="showProgress && consumerHasPayg" [ngClass]="{'text-color__warning': (progress == 'In Progress'), 'text-color__success': (progress == 'Completed'), 'text-color__error': (progress == 'Error')}">{{progress}}</span>
    </h2>
    <!--<div class="btn-group">
        <ng-container *ngIf="!isEditing">
            <button class="focus-element" (click)="onEditClick()" *ngIf="consumerHasPayg"><span class="focus--content" tabindex="-1"  title="Edit tariffs"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>
            <button class="focus-element" *ngIf="progress != 'In Progress' && consumerHasPayg" (click)="getTarrifInteraction()"><span class="focus--content" tabindex="-1" title="Request current tariffs"><svg class="m-ic" [ngClass]="{'spin' : isProcessing}"><use xlink:href="#ic-refresh" href="#ic-refresh"></use></svg></span></button>
        </ng-container>
        <ng-container *ngIf="isEditing">
            <button class="focus-element" (click)="onEditClick(true)" *ngIf="consumerHasPayg"><span class="focus--content" tabindex="-1" title="Update tariff with inputted values"><svg class="m-ic"><use xlink:href="#ic-save" href="#ic-save"></use></svg></span></button>
            <button class="focus-element" (click)="onEditClick()" *ngIf="consumerHasPayg"><span class="focus--content" tabindex="-1" title="Cancel editing"><svg class="m-ic m-ic--sm"><use xlink:href="#ic-close" href="#ic-close"></use></svg></span></button>
        </ng-container>
    </div>-->
</div>
<div class="module--main text-center">
    <div class="block-num text-center" *ngIf="tariffs.length == 0">
        <span class="lg">N/A</span>
        <span class="sm">data not avaliable <br> call Switch2 Customer Services on <a href="tel:03333212010" class="focus-element"><span class="focus--content">0333 321 2010</span></a></span>
    </div>
    <form [formGroup]="form" style="flex:none">
        <div class="block-num max-width justify-center text-center" *ngFor="let items of tariffs">
            <ul class="stacked-list">
                <ng-container *ngFor="let item of items">
                    <li class="list--item list--item__no-border">
                        <svg class="list--item-ic">
                            <use attr.xlink:href="{{getSvgId(item.chargeIcon)}}" attr.href="{{getSvgId(item.chargeIcon)}}"></use>
                        </svg>
                        <div class="text inline">
                            <div><span class="h-uppercase h-bold h-text-sm block">{{item.altChargeName}}</span></div>
                            <span class="lg">{{item.unitCharge | currency:'GBP':'symbol':'1.5'}}</span>
                            <span class="sm">per {{item.unitOfMeasure}}</span>
                        </div>
                    </li>
                    <li class="list--item" *ngIf="isEditing">
                        <svg class="list--item-ic"><use xlink:href="" href=""></use></svg>
                        <div class="std-form text list--item-edit">
                            <div class="form-group form-group__medium">
                                <label for="new-tariff" class="text-left">New tariff</label>
                                <div class="input-addon left right">
                                    <div class="addon h-bold lg">£</div>
                                    <input type="text" autocomplete="off" placeholder="0.0000" [textMask]="{mask:numberMask, guide: false}" [formControl]="form.controls.tariffs.controls[item.index]" numberInputHandler [numberInputDecimalPlaces]="4" [numberInputNegativeEnabled]="false" class="input__border-bottom input__color-success xl">
                                    <div class="addon">per {{item.unitOfMeasure}}</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </div>
    </form>
</div>
